<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
// import base from './base.js'
import EnvBase from './env.js'
import SvrApi from './svrapi.js'
import { mapMutations } from 'vuex'
import wsc from '../src/vendor/qnbar/msgWsClient'
import { ws_base } from '../src/http/ws_base'
import { agencyQnbarRequest } from '@/utils'
var PT = EnvBase.PT
export default {
  name: 'app',
  beforeMount: function() {
        // 平台
    const self = this

        // --------- 固定统一登录初始化流程 ---------
    var withLocalSessClean = PT.qnlogin.findGetParameter('local_sess_clean')
    if (withLocalSessClean) {
      PT.apiClient.blockQuery()
    }
        // 登录模块的配置和初始化
    var LoginRunConf = {}

        // 本地session ok时执行
    function OnLocalSessionOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk
    }
        // 没有本地session时执行, 注意不是完全没有，可能带ticket或tgc...
    function OnLocalSessionNotOkDoFunc() {
      self.hasLogin = PT.qnlogin.isLocalSessOk
    }

        // 平台本地ticket校验并返回session的接口
    function OnHasTicketDoFunc(ticket) {
      var postParams = {
        service_ticket: ticket
      }
      PT.apiClient.query(SvrApi.loginValidateTicket, postParams, PT.qnlogin.handleTicketValidate)
      PT.apiClient.blockQuery()
    }

        // 避免无失败卡页面
    function OnTicketValidateFailFunc() {
      alert('登录ticket验证失败！请尝试重新登录')
      PT.qnlogin.logout()
      this.hasLogin = PT.qnlogin.isLocalSessOk
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl)
    }

    function OnSessionFailDoFunc() {
            // 本地和passport都失败，完全没有session
      PT.apiClient.blockQuery()
            // console.log('OnSessionFailDoFunc');
      self.jumpLogin()
    }

        // ----------- 外部执行带入登录工具的配置 ------------
    LoginRunConf.JumpBackUrl = PT.config.loginJumpBackUrl  // 登录回跳地址
    LoginRunConf.OnLocalSessionOkDo = OnLocalSessionOkDoFunc
    LoginRunConf.OnLocalSessionNotOkDo = OnLocalSessionNotOkDoFunc
    LoginRunConf.OnHasTicketDo = OnHasTicketDoFunc
    LoginRunConf.OnSessionFailDo = OnSessionFailDoFunc
    LoginRunConf.OnTicketValidateFail = OnTicketValidateFailFunc

        // ---- 登录ok后的执行和鉴权的执行 ----

        // 权限检查对象
        // 全局 - 获取当前登录用户的全量权限code
    function checkAllUserPermission() {
            // 开始执行鉴权请求
      PT.apiClient.blockQuery()
      PT.permissionChecker.queryAllPermissions(PT.apiClient, PT.config.platformUsagespace, PT.qnlogin.getLocalSess(), onAllPermissionQueryOK)
    }

        // 全局 - 登录OK后执行内容
    function onPageSessionOk() {
      self.user_title = '读取中...'
      self.hasLogin = PT.qnlogin.isLocalSessOk

            // 有登录，就执行权限获取
      checkAllUserPermission()
    }

        // 执行passport登录模块的页面初始化运行过程
    LoginRunConf.OnAfterLocalSessionOkDo = onPageSessionOk
    PT.qnlogin.runInPageReady(LoginRunConf)

        //
    function onAllPermissionQueryOK(rsp) {
            // 勿动~
      PT.apiClient.resumeQuery()
            // 同步权限到 Vuex，确保 Sidebar 等组件能读取
      if (rsp && rsp.data) {
        self.$store.commit('SET_PERMISSIONS', rsp.data)
      }
            // 判断是否有权限修改密码和登出
      self.islocal_user = PT.permissionChecker.hasPermission('local_user_base_module')
            // console.log(self.islocal_user)
      eventBus.$emit('islocal_user', self.islocal_user)
    }
        // self.clickstore();
  },

  mounted: function() {

    let setTime = setTimeout(() => {
      this.$store.dispatch('getAuditShopInfo')
      clearTimeout(setTime)
      setTime = null
    }, 1000)
    const setIntervalShopInfo = setInterval(() => {
      this.$store.dispatch('getAuditShopInfo')
    }, 300000)
        // this.$store.dispatch('getAuditShopInfo')
    const self = this

        // 【业务逻辑入口改到这里了！！！】
    PT.apiClient.query(SvrApi.loginUserInfo, '', function(rsp) {
      if (rsp.code == 0) {
        localStorage.setItem('user_data', JSON.stringify(rsp.data))
        self.SET_DATA(rsp.data)
        var dispName = rsp.data.name || rsp.data.agent_name
        handleWs()
        // eslint-disable-next-line no-undef
        eventBus.$emit('user_title', dispName)
      } else {
        alert('获取用户信息错误！')
      }
      agencyQnbarRequest('getdetail')
              .then((res) => {
                // 新起点合作商
                const data = res.data
                localStorage.setItem('base_info', JSON.stringify(data))
                if (res.data.xqd === '1') {
                  // 登出
                  self.runLogout()
                  localStorage.removeItem('base_info')
                }
              })
    })

    function showDeskTopNotice(title, msg) {
      var Notification =
            window.Notification ||
            window.mozNotification ||
            window.webkitNotification
      if (Notification) {
        Notification.requestPermission(function(status) {
              // console.log('status: ' + status)
              // status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
          if (status != 'granted') {
            return
          } else {
            var tag = 'qnbar' + Math.random()
            var notify = new Notification(title, {
              dir: 'auto',
              lang: 'zh-CN',
              tag: tag, // 实例化的notification的id
              icon:
                    'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80', // 通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
              body: msg // 通知的具体内容
            });
            (notify.onclick = function() {
                  // 如果通知消息被点击,通知窗口将被激活
              window.focus()
            }),
                  (notify.onerror = function() {
                    // console.log("HTML5桌面消息出错！！！");
                  })
            notify.onshow = function() {
                  // setTimeout(function(){
                  //     notify.close();
                  // },2000)
            }
            notify.onclose = function() {
                  // console.log("HTML5桌面消息关闭！！！");
            }
          }
        })
      } else {
        alert('您的浏览器不支持桌面消息')
      }
    }

        // ----------- 执行一个全局或当前页的websocket -----------
    function handleWs() {
          // ---- 1.身份绑定 -----
          // 测试内容: 商户页面通知业务
          // 门店序号绑定
          // sn = agent_guid
      const storeSn = JSON.parse(localStorage.getItem('user_data')).agent_guid + '@agent' // sn@group self.agent_id
          // console.log(storeSn)
          // 业务-组和序号 的绑定
      const bzAndIdBindMap = new Map()
      bzAndIdBindMap.set(ws_base.AGENT_WEB_MSG, storeSn)
          // ---- 2.业务处理器绑定 ----
          // 测试内容: 商户页面通知业务
          // 对收到的消息进行处理
      const bzMchWebNtfDealer = function(protoMsg) {
              // todo 这里最好也配置化然后处理
        window.eventBus.$emit(protoMsg.getOp(), JSON.parse(protoMsg.getBzdata())) // 发送事件
        if (protoMsg.getOp() == 'prjt_retail_ntf') { // 投影商品购买通知...
          if (protoMsg.getBzdata()) {
                      // console.log(protoMsg.getBzdata());
            const data = JSON.parse(protoMsg.getBzdata())
            const sendData = {
              total: data.num
            }
            if (data.type == 1) {
              var Prompt = document.getElementById('Prompt')
              Prompt.play()
              showDeskTopNotice('待配送数量', data.num)
              self.$store.commit('SET_WAIT_ORDER', sendData)
              self.$store.commit('GET_ISORDER_DATA', true)
            } else if (data.type == 2) {
              self.$store.commit('SET_WAIT_ORDER', sendData)
              self.$store.commit('GET_ISORDER_DATA', true)
            } else {
                        // console.log('error')
            }
          } else {
                      // console.log("?????");
          }
        }
          // 如果当前路由无法处理，使用其他形式传达通知
      }
      const bzMchHotelRoomMgr = function(protoMsg) {
        window.eventBus.$emit(protoMsg.getOp(), protoMsg.getBzdata()) // 发送事件
      }
      const bzMsgDealerMap = new Map()
      bzMsgDealerMap.set(ws_base.AGENT_WEB_MSG, bzMchHotelRoomMgr)
          // ---- 3.鉴权信息获取 ----
      const PT_NAME = PT.config.platformUsagespace

          // ---- 4.初始化并启动客户端 ----
      wsc.MsgWsClient.init({
        proto: PT.config.wsProto,
        host: PT.config.wsHost,                 // 必填
        port: PT.config.wsPort,                 // 必填
        path: ws_base.wsPath,                 // 必填
        authSys: PT_NAME,                     // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(),   // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap,            // 必填
        bzMsgDealerMap: bzMsgDealerMap       // 必填
              // debug : true,
      })
      wsc.MsgWsClient.startRun()
      const obj = {
        proto: PT.config.wsProto,
        host: PT.config.wsHost,                 // 必填
        port: PT.config.wsPort,                 // 必填
        path: ws_base.wsPath,                 // 必填
        authSys: PT_NAME,                     // 必填 项目配置中的平台字符串
        authKey: PT.qnlogin.getLocalSess(),   // 必填 本地系统的session key/token
        toBindMap: bzAndIdBindMap,            // 必填
        bzMsgDealerMap: bzMsgDealerMap       // 必填
      }
      console.log(obj)

          // ------- 发送消息功能暂时禁用中 -------
          // test send a msg to self
          // wsc.MsgWsClient.sendMsg(BZ_MCH_WEB_NTF, "prjt_retail_ntf", "test send and receive self", storeSn);
          // test send a msg to projector
          // wsc.MsgWsClient.sendMsg(BZ_PRJT_TXT_MSG, "send_msg", "hello!!!", "2@p");
    }
  },
  methods: {
    ...mapMutations([
      'SET_DATA'
    ]),
        // -- 这坨是登录的 --
    handleCheckLoginInfoFail() {
            // 单一用户类型，直接进入登录
      console.log('handleCheckLoginInfoFail')
      PT.qnlogin.jumpToCheck(PT.config.loginJumpBackUrl, 'agent') // agent 官方运营人员  /  agent 合作商  /  merchant 商户
      return
      this.hasLogin = PT.qnlogin.isLocalSessOk
    },

    handleOnLogout(rsp) {
      window.location.href = decodeURIComponent(PT.config.loginJumpBackUrl)
    },

    jumpLogin() {
            // console.log('jumpLogin');
      PT.qnlogin.firstCheck(PT.config.loginJumpBackUrl, this.handleCheckLoginInfoFail)
    },

    runLogout() {
      var postParams = {
        local_sess: PT.qnlogin.getLocalSess()
      }
      PT.apiClient.query(SvrApi.logout, postParams, this.handleOnLogout)
      PT.qnlogin.logout()

      this.hasLogin = PT.qnlogin.isLocalSessOk
    }
  }// end of methods
}
</script>

<style lang="scss">
@import '~normalize.css/normalize.css'; // normalize.css 样式格式化
@import './styles/index.scss'; // 全局自定义的css样式
</style>



// WEBPACK FOOTER //
// src/App.vue?1aac1bb5